/*
* 解决ios手机输入框收回后，被挤掉的页面没有回弹到正常
* */

export default {
  data() {
    return {
      windowHeight: 0
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
  },
  methods:{
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight === windowFocusHeight) {
        return
      }
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    }
  }
}